import { render, staticRenderFns } from "./successTransfer.vue?vue&type=template&id=51502333&scoped=true&"
import script from "./successTransfer.vue?vue&type=script&lang=js&"
export * from "./successTransfer.vue?vue&type=script&lang=js&"
import style0 from "./successTransfer.vue?vue&type=style&index=0&id=51502333&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51502333",
  null
  
)

export default component.exports